import { isOwnedStation } from '@app/core/stations/helpers';
import { Box } from '@mui/material';
import { Redirect } from 'react-router-dom';
import { useFragment } from '../../hooks/useFragment';
import { FragmentSocialPublishView } from './FragmentSocialPublishView';
import { FragmentDeliveryStatus } from './external-export/FragmentDeliveryStatus';

/**
 * Export "Publish" tab content: social platforms and external export.
 */
export function FragmentPublishView() {
  const { fragment, station } = useFragment();

  if (!isOwnedStation(station)) {
    return <Redirect to={`/fragments/${fragment.id}`} />;
  }

  return (
    <Box sx={{ maxWidth: 'md' }}>
      <FragmentSocialPublishView />
      <Box mt={4}>{fragment.mediaCompletedAt ? <FragmentDeliveryStatus /> : null}</Box>
    </Box>
  );
}
